import { useMutation } from '@tanstack/react-query';

import { validatePhoneNumberApi } from '../api';

export default function useValidatePhoneMutation(config?: any) {
  return useMutation(validatePhoneNumberApi, config);
}
